import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledSelectsRow = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  flexWrap: "wrap",
  rowGap: theme.spacing(1),
  "& > .MuiFormControl-root": {
    flex: "1 1 160px",
    minWidth: 0,
  },
}));
